<script setup lang="ts">
import { VButton, VDropdownMultiple, VIcon, VTextField } from '@/modules/shared/components'
import VSelect from '../../../components/v-select.vue'

const props = defineProps<{
  form: any
  v$: any
  adminOptions: { label: string; value: string }[]
  isNewRecord: boolean
}>()

defineExpose({
  isValid: async () => {
    const fields = ['admin_signer_id', 'admin_ids']
    const results = await Promise.all(fields.filter((f) => props.v$[f]).map((f) => props.v$[f].$validate()))
    return results.every(Boolean)
  },
})
</script>

<template>
  <div class="space-y-4">
    <VTextField v-model="form.fund_gp_name" label="General Partner" property="fund_gp_name" :v$="v$" />

    <VTextField
      v-if="isNewRecord"
      v-model="form.company_name"
      label="Management Company"
      property="company_name"
      :v$="v$"
    />

    <VSelect
      v-model="form.admin_signer_id"
      label="Who should sign documents?"
      :options="adminOptions"
      property="admin_signer_id"
      :v$="v$"
    />

    <fieldset>
      <label class="mb-1 block text-sm font-medium text-gray-700">
        Which individuals should have administrator rights?
      </label>
      <VDropdownMultiple
        aligned="left"
        class="z-auto"
        :options="adminOptions"
        property="admin_ids"
        v-model="form.admin_ids"
        :show-selected-list="true"
        :drop-up="true"
      >
        <VButton size="xl" class="w-full">
          <div class="flex items-center justify-between">
            <div>Select multiple...</div>
            <VIcon name="ChevronSelectorVertical" />
          </div>
        </VButton>
      </VDropdownMultiple>
      <p class="mt-2 text-sm text-gray-500">By default, all group admins have administrator rights to this Fund.</p>
    </fieldset>
  </div>
</template>
